import { render } from "./CourseGPT.vue?vue&type=template&id=44139f7d&scoped=true"
import script from "./CourseGPT.vue?vue&type=script&lang=js"
export * from "./CourseGPT.vue?vue&type=script&lang=js"

import "./CourseGPT.vue?vue&type=style&index=0&id=44139f7d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44139f7d"]])

export default __exports__